'use client';

import { ReactNode, useState } from 'react';
import { AuthProviderContext } from './auth-provider-context';

type AuthProviderContextProviderProps = {
  children: ReactNode;
};

export function AuthProviderContextProvider(props: AuthProviderContextProviderProps) {
  const { children } = props;
  const [returnTo, setReturnTo] = useState<string | null>(null);

  return <AuthProviderContext.Provider value={{ returnTo, setReturnTo }}>{children}</AuthProviderContext.Provider>;
}
